import { render, staticRenderFns } from "./GeneralInputTable.vue?vue&type=template&id=09858656&scoped=true&"
import script from "./GeneralInputTable.vue?vue&type=script&lang=js&"
export * from "./GeneralInputTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInputTable.vue?vue&type=style&index=0&id=09858656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09858656",
  null
  
)

export default component.exports